<ng-container *transloco="let t; prefix: 'orders'">

    <span class="title-medium emphasized section-title">{{ 'orders.ui.selezionaProdotti' | transloco }}</span>

    <form class="form" [formGroup]="filtersForm">
        <div class="searchbar-row">
            <mat-form-field appearance="outline" class="searchbar" subscriptSizing="dynamic">
                <input matInput [placeholder]="'orders.ui.cercaProdotto' | transloco" formControlName="searchText">
                <div matSuffix class="search-icon-wrapper">
                    <i class="fa-regular fa-magnifying-glass"></i>
                </div>
            </mat-form-field>

            <button type="button" matButton class="filter-trigger-button" (click)="toggleFilters()">
                <i class="fa-regular fa-filter"></i>
                {{ 'orders.ui.filtri' | transloco }}
            </button>
        </div>
    </form>

    <div class="actions">
        <button matButton="filled" type="button" class="confirm-button" (click)="confirmSelection()">
            {{ 'orders.ui.conferma' | transloco }}
        </button>
    </div>

    @if (filtersOpen()) {
        <form class="filters-card-form" [formGroup]="filtersForm">
            <mat-card class="filters-card">
                <mat-card-content class="filters-card-content">

                    <mat-button-toggle-group
                        class="toggle plc-type-toggle"
                        hideSingleSelectionIndicator="true"
                        [value]="plcType()"
                        (change)="onPlcTypeChange($event.value)">
                        <mat-button-toggle value="">{{ 'orders.ui.tutti' | transloco }}</mat-button-toggle>
                        <mat-button-toggle value="OIL">Oil</mat-button-toggle>
                        <mat-button-toggle value="NONOIL">Non Oil</mat-button-toggle>
                    </mat-button-toggle-group>

                    <div class="price-filters-row">
                        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                            <mat-label>{{ 'orders.ui.prezzoMinimo' | transloco }}</mat-label>
                            <input matInput type="number" formControlName="prezzoMin" placeholder="0,00">
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                            <mat-label>{{ 'orders.ui.prezzoMassimo' | transloco }}</mat-label>
                            <input matInput type="number" formControlName="prezzoMax" placeholder="0,00"
                                [min]="filtersForm.controls.prezzoMin.value">
                            @if (filtersForm.controls.prezzoMax.hasError('min')) {
                                <mat-error>{{ 'orders.ui.deveEssereMaggioreOUgualeAlPrezzoMinimo' | transloco }}</mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                        <mat-label>PLC1</mat-label>
                        <mat-select formControlName="plc1" multiple [placeholder]="'orders.ui.tutti' | transloco">
                            @for (opt of visiblePlc1Options; track opt.value) {
                                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                        <mat-label>PLC2</mat-label>
                        <mat-select formControlName="plc2" multiple [placeholder]="'orders.ui.tutti' | transloco">
                            @for (opt of visiblePlc2Options; track opt.value) {
                                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    @if (plcType() !== 'NONOIL') {
                        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                            <mat-label>{{ 'orders.ui.tipoOlio' | transloco }}</mat-label>
                            <mat-select formControlName="tipiOlio" multiple [placeholder]="'orders.ui.tutti' | transloco">
                                @for (opt of tipiOlioOptions; track opt.value) {
                                    <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                            <mat-label>{{ 'orders.ui.segmentoMercato' | transloco }}</mat-label>
                            <mat-select formControlName="segmentiMercato" multiple [placeholder]="'orders.ui.tutti' | transloco">
                                @for (opt of segmentiMercatoOptions; track opt.value) {
                                    <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }

                    <mat-checkbox class="filter-field" formControlName="disponibili">{{ 'orders.ui.soloDisponibili' | transloco }}</mat-checkbox>

                    <div class="competitor-filter">
                        <span class="body-medium emphasized competitor-filter-title">{{ 'orders.ui.ricercaCorrispettivoCompetitor' | transloco }}</span>

                        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                            <mat-label>{{ 'orders.ui.marchio' | transloco }}</mat-label>
                            <input matInput formControlName="competitorMarchio" [matAutocomplete]="autoCompetitorMarchio" [placeholder]="'orders.ui.tutti' | transloco">
                            <span matSuffix class="autocomplete-suffix">
                                @if (filtersForm.get('competitorMarchio')?.value) {
                                    <button mat-icon-button type="button" class="clear-suffix-button round-icon-button"
                                        [attr.aria-label]="'orders.ui.svuotaMarchio' | transloco" (click)="clearFilterField('competitorMarchio')">
                                        <i class="fa-regular fa-xmark"></i>
                                    </button>
                                } @else {
                                    <i class="fa-regular fa-chevron-down icon-suffix"></i>
                                }
                            </span>
                            <mat-autocomplete #autoCompetitorMarchio="matAutocomplete">
                                @for (opt of filteredCompetitorMarchio | async; track opt) {
                                    <mat-option [value]="opt">{{ opt }}</mat-option>
                                }
                            </mat-autocomplete>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                            <mat-label>{{ 'orders.ui.nomeProdotto' | transloco }}</mat-label>
                            <input matInput formControlName="competitorNomeProdotto" [matAutocomplete]="autoCompetitorNomeProdotto" [placeholder]="'orders.ui.tutti' | transloco">
                            <span matSuffix class="autocomplete-suffix">
                                @if (filtersForm.get('competitorNomeProdotto')?.value) {
                                    <button mat-icon-button type="button" class="clear-suffix-button round-icon-button"
                                        [attr.aria-label]="'orders.ui.svuotaNomeProdotto' | transloco" (click)="clearFilterField('competitorNomeProdotto')">
                                        <i class="fa-regular fa-xmark"></i>
                                    </button>
                                } @else {
                                    <i class="fa-regular fa-chevron-down icon-suffix"></i>
                                }
                            </span>
                            <mat-autocomplete #autoCompetitorNomeProdotto="matAutocomplete">
                                @for (opt of filteredCompetitorNomeProdotto | async; track opt) {
                                    <mat-option [value]="opt">{{ opt }}</mat-option>
                                }
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>

                    <button type="button" matButton class="filter-trigger-button advanced-filters-trigger" (click)="toggleAdvancedFilters()">
                        <i class="fa-regular fa-filter"></i>
                        {{ 'orders.ui.filtriAvanzati' | transloco }}
                    </button>

                    @if (advancedFiltersOpen()) {
                        <div class="technical-filter">
                            <span class="body-medium emphasized technical-filter-title">{{ 'orders.ui.filtroTecnico' | transloco }}</span>

                            @for (category of technicalFilterCategories; track category.key) {
                                <div class="technical-filter-row">
                                    <span class="body-medium technical-filter-row-title">{{ category.label }}</span>
                                    <mat-chip-listbox multiple="true">
                                        @for (option of category.options; track option) {
                                            <mat-chip-option
                                                [selected]="isTechnicalFilterSelected(category.key, option)"
                                                (selectionChange)="onTechnicalFilterSelect($event, category.key, option)">
                                                {{ technicalOptionKeys[option] ? (technicalOptionKeys[option] | transloco) : option }}
                                            </mat-chip-option>
                                        }
                                    </mat-chip-listbox>
                                </div>
                            }
                        </div>
                    }

                </mat-card-content>

                <mat-card-actions align="end">
                    <button matButton type="button" (click)="resetFilters()">{{ 'orders.ui.annulla' | transloco }}</button>
                    <button matButton="filled" type="button" [disabled]="filtersForm.invalid"
                        (click)="applyFilters()">{{ 'orders.ui.applica' | transloco }}</button>
                </mat-card-actions>
            </mat-card>
        </form>
    }

    <div class="active-filters">
        <span class="body-medium emphasized">{{ 'orders.ui.filtriAttivi' | transloco }} </span>
        <mat-chip-set>
            @for (filter of getActiveTechnicalFilters(); track filter.value) {
                <mat-chip (removed)="removeTechnicalFilter(filter.key, filter.value)">
                    {{ technicalOptionKeys[filter.value] ? (technicalOptionKeys[filter.value] | transloco) : filter.value }}
                    <button matChipRemove [attr.aria-label]="'orders.ui.rimuoviFiltro' | transloco">
                        <i class="fa-regular fa-xmark"></i>
                    </button>
                </mat-chip>
            }
        </mat-chip-set>
    </div>

    <div class="view-bar">
        <mat-button-toggle-group
            [value]="selectedView"
            (change)="onViewChange($event.value)"
            class="toggle"
            hideSingleSelectionIndicator="true">
            @for (option of viewOptions; track option.value) {
                @if ((!isMobile || option.value !== 'list') && (hasCustomer || option.value !== 'purchased')) {
                    <mat-button-toggle [value]="option.value">
                        <i [attr.class]="'fa-' + option.iconVariant + ' ' + option.icon"></i> {{ option.label }}
                    </mat-button-toggle>
                }
            }
        </mat-button-toggle-group>
    </div>

    <!-- Gli ultimi acquistati si mostrano a card, come nel Figma -->
    @switch (selectedView === 'purchased' ? 'card' : selectedView) {
        @case ('list') {
            <ui-table-view
                class="table-view"
                [data]="tableProducts"
                [columnsInfo]="columnsInfo"
                [sortColumns]="currentSortColumns"
                (sortChange)="onSortChange($event)"
                (rowClicked)="openProductDetail($event.idProdotto)">
            </ui-table-view>
        }
        @case ('card') {
            <div class="catalog-card-list">
                @for (product of catalogProducts; track product.idProdotto) {
                    <mat-card class="catalog-card" (click)="openProductDetail(product.idProdotto)">
                        <mat-card-content>
                            <div class="catalog-card-header">
                                <span class="body-medium emphasized">{{ product.nomeProdotto }}</span>
                                <prd-availability-chip [stock]="product.stock" />
                            </div>

                            <span class="body-small">{{ product.plc1 }} - {{ product.plc2 }}</span>

                            <div class="catalog-card-price-row">
                                <div class="title-medium emphasized catalog-card-price">
                                    {{ product.prezzo | translocoCurrency: 'symbol' : { minimumFractionDigits: 4, maximumFractionDigits: 4 } : 'EUR' }}
                                </div>
                                <div class="catalog-card-badges">
                                    <prd-category-chip [badges]="product.badge" />
                                </div>
                            </div>

                            <mat-divider></mat-divider>

                            <div class="catalog-card-details">
                                <div class="catalog-card-detail-item">
                                    <span class="catalog-card-detail-label body-medium">{{ 'orders.ui.codProdotto' | transloco }}</span>
                                    <span class="catalog-card-detail-value body-medium emphasized">{{ product.sku }}</span>
                                </div>
                                <div class="catalog-card-detail-item">
                                    <span class="catalog-card-detail-label body-medium">{{ 'orders.ui.nomeImballo' | transloco }}</span>
                                    <span class="catalog-card-detail-value body-medium emphasized">{{ product.nomeImballo }}</span>
                                </div>
                                <div class="catalog-card-detail-item">
                                    <span class="catalog-card-detail-label body-medium">{{ 'orders.ui.qtaFatturabile' | transloco }}</span>
                                    <span class="catalog-card-detail-value body-medium emphasized">{{ product.unitaFatturabile }} {{ product.unitaMisura }}</span>
                                </div>
                                <div class="catalog-card-detail-item">
                                    <span class="catalog-card-detail-label body-medium">{{ 'orders.ui.scala' | transloco }}</span>
                                    <span class="catalog-card-detail-value body-medium emphasized">{{ product.scala }}</span>
                                </div>
                                <div class="catalog-card-detail-item">
                                    <span class="catalog-card-detail-label body-medium">{{ 'orders.ui.deposito' | transloco }}</span>
                                    <span class="catalog-card-detail-value body-medium emphasized">{{ product.deposito }}</span>
                                </div>
                            </div>

                            <button matButton="filled" class="catalog-cart-button" (click)="openAddToCartDialog($event, product)">
                                <i class="fa-regular fa-plus"></i>
                                {{ 'orders.ui.aggiungiAllaProposta' | transloco }}
                            </button>
                        </mat-card-content>
                    </mat-card>
                }
            </div>
        }
        @case ('grouped') {
            <div class="catalog-card-list">
                @for (product of groupedProducts; track product.idProdottoMaster) {
                    <mat-card class="catalog-card">
                        <mat-card-content>
                            <div class="catalog-card-header">
                                <span class="body-medium emphasized">{{ product.nomeProdotto }}</span>
                            </div>

                            <span class="body-small">{{ product.descrizioneBreve ?? '-' }}</span>

                            @if (product.specifiche?.length) {
                                <mat-accordion>
                                    <mat-expansion-panel class="card-row-categories-panel catalog-card-accordion">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>{{ 'orders.ui.specifiche' | transloco }}</mat-panel-title>
                                        </mat-expansion-panel-header>
                                        <div class="card-row card-row-categories">
                                            <prd-category-chip [badges]="product.specifiche" [translate]="false" />
                                        </div>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            }

                            <mat-divider></mat-divider>

                            <button matButton class="catalog-detail-button" (click)="openProductDetail(product.idProdottoMaster)">
                                <i class="fa-regular fa-circle-info"></i>
                                {{ 'orders.ui.dettaglio' | transloco }}
                            </button>
                        </mat-card-content>
                    </mat-card>
                }
            </div>
        }
    }

    @if (selectedView === 'list' || selectedView === 'card' || selectedView === 'grouped' || selectedView === 'purchased') {
        <mat-paginator
            class="paginator"
            [length]="totalItems"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            [pageSizeOptions]="[5, 10, 25]"
            [hidePageSize]="true"
            (page)="onPageChange($event)">
        </mat-paginator>
    }

    <button matButton="filled" class="cart-floating-button" (click)="cartService.open(false)"
        [matBadge]="cartService.cart()?.numeroRighe"
        [matBadgeHidden]="!cartService.cart()?.numeroRighe"
        matBadgeColor="warn"
        >
        <i class="fa-regular fa-cart-shopping"></i>
        {{ 'orders.ui.carrello' | transloco }}
    </button>

</ng-container>
